const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`, `6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`, 6, 85), new Map([[`class`, `o-container--prose o-container--pad`], [`content_class`, `o-rhythm`]]), true, false, 6));
            }

            getTemplateName() {
                return `6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`, ``);
            }
        }],
        [85, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`, 6);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>
      This paragraph has no alignment.
    </p>
    <p class="
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, (context.has(`alignment`) ? context.get(`alignment`) : null), `html`, null, true]));
                this.echo(`
      has-text-color
      has-fuchsia-lighter-color
      has-background
      has-purple-darker-background-color">
      This paragraph has
      <b>`);
                this.echo(this.env.getFilter('escape').traceableCallable(21, this.source)(...[this.env, this.env.getFilter('replace').traceableCallable(21, this.source)(...[(((context.has(`alignment`))) ? (this.env.getFilter('default').traceableCallable(21, this.source)(...[(context.has(`alignment`) ? context.get(`alignment`) : null), `no`])) : (`no`)), new Map([[`align`, ``]])]), `html`, null, true]));
                this.echo(` alignment</b> and
      custom colors.
    </p>
    <p>
      Here’s another ordinary paragraph with no alignment. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    </p>
    `);
                context.proxy[`extra_div`] = this.isIn((context.has(`alignment`) ? context.get(`alignment`) : null), new Map([[0, `alignleft`], [1, `alignright`], [2, `aligncenter`]]));
                this.echo(`    `);
                if ((context.has(`extra_div`) ? context.get(`extra_div`) : null)) {
                    this.echo(`      <div class="wp-block-image">
    `);
                }
                this.echo(`    <figure class="`);
                if ( !(context.has(`extra_div`) ? context.get(`extra_div`) : null)) {
                    this.echo(`wp-block-image `);
                }
                this.echo(this.env.getFilter('escape').traceableCallable(31, this.source)(...[this.env, (context.has(`alignment`) ? context.get(`alignment`) : null), `html`, null, true]));
                this.echo(`">
      <img src="/media/MtBlanc1.jpg" alt="Mont Blanc">
      <figcaption>This WordPress Image Block with a caption has <b>`);
                this.echo(this.env.getFilter('escape').traceableCallable(33, this.source)(...[this.env, this.env.getFilter('replace').traceableCallable(33, this.source)(...[(((context.has(`alignment`))) ? (this.env.getFilter('default').traceableCallable(33, this.source)(...[(context.has(`alignment`) ? context.get(`alignment`) : null), `no`])) : (`no`)), new Map([[`align`, ``]])]), `html`, null, true]));
                this.echo(` alignment</b>!</figcaption>
    </figure>
    `);
                if ((context.has(`extra_div`) ? context.get(`extra_div`) : null)) {
                    this.echo(`      </div>
    `);
                }
                this.echo(`    <p>
      One more ordinary paragraph. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse at sapien porttitor risus blandit posuere. Sed in malesuada ligula. Nam vulputate metus sed nibh vulputate, sed varius neque tincidunt.
    </p>
  `);
            }

            getTemplateName() {
                return `6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46');

let template = env.loadTemplate('6575586d12d47a9ff4163657f1e78b6fa928f642709fbeebb20c25082b2d9e46');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/alignment.twig", args: context }
     );
     return rendered;;
};